"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LV = void 0;
exports.LV = {
    numericCode: '428',
    alpha2Code: 'LV',
    alpha3Code: 'LVA',
    englishName: {
        short: 'Latvia',
        full: 'the Republic of Latvia',
    },
    names: {
        full: {
            en: 'the Republic of Latvia',
            fr: 'la République de Lettonie',
            lv: 'Latvija',
        },
        short: {
            en: 'Latvia',
            fr: 'Lettonie (la)',
            lv: 'Latvija',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'lv',
            languageAlpha3Code: 'lav',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'LV-002': {
            numericCode: '428',
            code: 'LV-002',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Aizkraukles novads',
            },
        },
        'LV-007': {
            numericCode: '428',
            code: 'LV-007',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Alūksnes novads',
            },
        },
        'LV-011': {
            numericCode: '428',
            code: 'LV-011',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ādažu novads',
            },
        },
        'LV-015': {
            numericCode: '428',
            code: 'LV-015',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Balvu novads',
            },
        },
        'LV-016': {
            numericCode: '428',
            code: 'LV-016',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Bauskas novads',
            },
        },
        'LV-022': {
            numericCode: '428',
            code: 'LV-022',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Cēsu novads',
            },
        },
        'LV-026': {
            numericCode: '428',
            code: 'LV-026',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Dobeles novads',
            },
        },
        'LV-033': {
            numericCode: '428',
            code: 'LV-033',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Gulbenes novads',
            },
        },
        'LV-041': {
            numericCode: '428',
            code: 'LV-041',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Jelgavas novads',
            },
        },
        'LV-042': {
            numericCode: '428',
            code: 'LV-042',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Jēkabpils novads',
            },
        },
        'LV-047': {
            numericCode: '428',
            code: 'LV-047',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Krāslavas novads',
            },
        },
        'LV-050': {
            numericCode: '428',
            code: 'LV-050',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Kuldīgas novads',
            },
        },
        'LV-052': {
            numericCode: '428',
            code: 'LV-052',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ķekavas novads',
            },
        },
        'LV-054': {
            numericCode: '428',
            code: 'LV-054',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Limbažu novads',
            },
        },
        'LV-056': {
            numericCode: '428',
            code: 'LV-056',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Līvānu novads',
            },
        },
        'LV-058': {
            numericCode: '428',
            code: 'LV-058',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ludzas novads',
            },
        },
        'LV-059': {
            numericCode: '428',
            code: 'LV-059',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Madonas novads',
            },
        },
        'LV-062': {
            numericCode: '428',
            code: 'LV-062',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Mārupes novads',
            },
        },
        'LV-067': {
            numericCode: '428',
            code: 'LV-067',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ogres novads',
            },
        },
        'LV-068': {
            numericCode: '428',
            code: 'LV-068',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Olaines novads',
            },
        },
        'LV-073': {
            numericCode: '428',
            code: 'LV-073',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Preiļu novads',
            },
        },
        'LV-077': {
            numericCode: '428',
            code: 'LV-077',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Rēzeknes novads',
            },
        },
        'LV-080': {
            numericCode: '428',
            code: 'LV-080',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ropažu novads',
            },
        },
        'LV-087': {
            numericCode: '428',
            code: 'LV-087',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Salaspils novads',
            },
        },
        'LV-088': {
            numericCode: '428',
            code: 'LV-088',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Saldus novads',
            },
        },
        'LV-089': {
            numericCode: '428',
            code: 'LV-089',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Saulkrastu novads',
            },
        },
        'LV-091': {
            numericCode: '428',
            code: 'LV-091',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Siguldas novads',
            },
        },
        'LV-094': {
            numericCode: '428',
            code: 'LV-094',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Smiltenes novads',
            },
        },
        'LV-097': {
            numericCode: '428',
            code: 'LV-097',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Talsu novads',
            },
        },
        'LV-099': {
            numericCode: '428',
            code: 'LV-099',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Tukuma novads',
            },
        },
        'LV-101': {
            numericCode: '428',
            code: 'LV-101',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Valkas novads',
            },
        },
        'LV-102': {
            numericCode: '428',
            code: 'LV-102',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Varakļānu novads',
            },
        },
        'LV-106': {
            numericCode: '428',
            code: 'LV-106',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ventspils novads',
            },
        },
        'LV-111': {
            numericCode: '428',
            code: 'LV-111',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Augšdaugavas novads',
            },
        },
        'LV-112': {
            numericCode: '428',
            code: 'LV-112',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Dienvidkurzemes Novads',
            },
        },
        'LV-113': {
            numericCode: '428',
            code: 'LV-113',
            category: {
                id: '211',
                names: {
                    en: {
                        singular: 'municipality',
                        plural: 'municipalities',
                    },
                    fr: {
                        singular: 'commune',
                        plural: '',
                    },
                    lv: {
                        singular: 'novads',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Valmieras Novads',
            },
        },
        'LV-DGV': {
            numericCode: '428',
            code: 'LV-DGV',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Daugavpils',
            },
        },
        'LV-JEL': {
            numericCode: '428',
            code: 'LV-JEL',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Jelgava',
            },
        },
        'LV-JUR': {
            numericCode: '428',
            code: 'LV-JUR',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Jūrmala',
            },
        },
        'LV-LPX': {
            numericCode: '428',
            code: 'LV-LPX',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Liepāja',
            },
        },
        'LV-REZ': {
            numericCode: '428',
            code: 'LV-REZ',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Rēzekne',
            },
        },
        'LV-RIX': {
            numericCode: '428',
            code: 'LV-RIX',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Rīga',
            },
        },
        'LV-VEN': {
            numericCode: '428',
            code: 'LV-VEN',
            category: {
                id: '248',
                names: {
                    en: {
                        singular: 'state city',
                        plural: 'state cities',
                    },
                    fr: {
                        singular: 'ville capitale',
                        plural: '',
                    },
                    lv: {
                        singular: 'valstspilsētas pašvaldība',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                lv: 'Ventspils',
            },
        },
    },
    cities: [
        {
            name: 'Valmiera',
            subdivision: 'Valmieras Rajons',
        },
        {
            name: 'Ventspils',
            subdivision: 'Ventspils',
        },
        {
            name: 'Vec-Liepāja',
            subdivision: 'Liepāja',
        },
        {
            name: 'Tukums',
            subdivision: 'Tukuma Rajons',
        },
        {
            name: 'Salaspils',
            subdivision: 'Salaspils',
        },
        {
            name: 'Riga',
            subdivision: 'Riga',
        },
        {
            name: 'Rēzekne',
            subdivision: 'Rēzekne',
        },
        {
            name: 'Ogre',
            subdivision: 'Ogre',
        },
        {
            name: 'Liepāja',
            subdivision: 'Liepāja',
        },
        {
            name: 'Jūrmala',
            subdivision: 'Jūrmala',
        },
        {
            name: 'Jelgava',
            subdivision: 'Jelgava',
        },
        {
            name: 'Jēkabpils',
            subdivision: 'Jēkabpils Municipality',
        },
        {
            name: 'Daugavpils',
            subdivision: 'Daugavpils municipality',
        },
        {
            name: 'Cēsis',
            subdivision: 'Cēsu Rajons',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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